import { Component, OnInit } from '@angular/core';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../share/component/base.component';
declare var $;
declare var tippy;
declare var jslib;
@Component({
  selector: 'reserve-component',
  templateUrl: './reserve.component.html'
})
export class ReserveComponent extends BaseComponent implements OnInit  {

  constructor(  
    public _sanitizer: DomSanitizer
  ) {
    super();
  }
  public contact;
  ngOnInit() {
    //取得聯絡人
    this.baseApi.apiGet('v1/member/companyUser',{}).then((c_res)=>{
      this.contact = c_res;
      this.Submit();
    });
  }

  public Data;
  Submit(){
    this.baseApi.apiGet('v1/member/session',{history:false}).then((res:any)=>{
      //console.log('session',res);
      //整理資料
      if(res){
        var newData = [];
        res.forEach(item => {
          var _e = item['Event'];
          var _self = item;
          //處理審核狀態
          _self['statusType'] =  this.StatusClass(_self['status']);
          var _index = newData.findIndex((evt)=>{
             return evt['evt']['id'] == item['Event']['id'];
           });
          if(_index > -1){
            newData[_index]['list'].push(_self);
          }else{
            var _n ={
              evt:_e,
              list:[_self]
            };
            newData.push(_n);
          }
        });
        //console.log('newData',newData);
        this.Data = newData;
        this.RenderTagHover();
      }
    });
  }

  StatusClass(index){
    var statusObj = {
      1:{name:'審核中',class:'checking'},
      2:{name:'審核通過',class:'passed'},
      3:{name:'審核不通過',class:'fail'},
      5:{name:'取消',class:'fail'}
    };
    return statusObj[index];
  };

  Cancel(item){
    //console.log('Cancel',item);
    var query = {
      id: item.buyer.buyer_id,
      session_id:item.session_id
    }
    //活動取消
    this.baseApi.apiPost(
      'v1/member/session/cancel?id=' + query.id + '&session_id=' + query.session_id
      ,{}).then((c_res)=>{
      this.pop.setConfirm({
        content:'活動取消成功!',
        checkTxt:'確認',
        event:()=>{
          this.Submit();
        }
      });
    });
  }

  SetEvtUser(evt,item){
    var mail = evt.target.value;
    console.log('SetEvtUser',mail,item);
    if(mail == ''){
      this.pop.setConfirm({
        content:'請選擇聯絡人!'
      });
      var old = item.user_id;
      $(evt.target).val(old);
    }else{
      //先詢問 確認後再執行
      this.pop.setConfirm({
        content:'請確認是否要更換參加人?',
        checkTxt:'確認',
        cancelTxt:'取消',
        event:()=>{
          var query = {
            session_id: item.session_id,
            email:mail
          }
          this.baseApi.apiPost(
            'v1/member/session/changeUser?session_id='
             + query.session_id + '&email='
             + query.email
            ,{}).then((c_res)=>{
            this.pop.setConfirm({
              content:'參加人變更成功!',
              checkTxt:'確認'
            });
            //回寫參加人
            item.user_id = mail;
          },(err)=>{
            var old = item.user_id;
            $(evt.target).val(old);
          });
        },
        cancelEvent:()=>{
          var old = item.user_id;
          $(evt.target).val(old);
        }
      });
      
    }

  }
  RenderTagHover(){
    setTimeout(()=>{
      this.ngzone.runOutsideAngular(()=>{

        window['tag_tip'] = 
          tippy('.hoverEvt span', {
            content: 'Loading...',
            theme:'tag',
            //trigger: 'click',
            allowHTML: true,
            interactive: true,
            onShow(instance) {
                var dom = instance['reference'];
                var param = {
                  txt : dom.innerText,
                  desc : dom.dataset.desc,
                  spec : dom.dataset.spec,
                  attach : dom.dataset.attach,
                  pid : dom.dataset.pid,
                  buyer : dom.dataset.buyer,
                  islogin : false
                };
                param.islogin = jslib.GetStorage('user') != null;
                ////console.log('instance param',param);
                var html = '<div class="tag_pop">';
                html += '<label>' +  param.txt + '</label>';
                //尚未登入顯示
                if(param.spec == 'false' && param.islogin == false){
                  html += '<p>登入查看詳細規格</p>';
                  html += '<div class="bottom"><span></span><span class="add" onclick="ToLogIn()"><i class="lock"></i>立即登入</span></div>';
                }else{
                  html += '<p>' + param.desc +  '</p>';
                  if(param.attach == 'true' && param.islogin){
                    var _url = '/brochure/download?buyer_id=' + param.buyer + '&product_id=' + param.pid;
                    html += '<div class="bottom"><span><i class="icon icon-attach-file">&#xe80a;</i><a href="' + _url + '" target="_blank">下載檔案</a></span><span class=""></span></div>';
                  }else{
                    html += '<div class="bottom"><span></span><span class="add"></span></div>';
                  }
                  html += '</div>';
                }

                instance.setContent(html);
              },
          });

      });
    },250);
  }

  VideoEvt(item){
    var d = item['sessionTime']['start'];
    var date = '';
    if(d){
      date = d.split('T');
    }
    //20220221移除
    // if(date[0]){
    //   this.pop.setConfirm({
    //     content:'<span class="view_alert"><img src="/assets/images/time-left.png" class="pop_img">本活動尚未開始，請於' + date[0] + '日<br/>由此入口進行視訊洽談</span>',
    //     checkTxt:'確認'
    //   });
    // }
  }
}
